function hasOwnDeepProperty(object, path) {
  if (!path) {
    return false;
  }
  const pathSplit = path.split('.');
  let childObject = object;
  for (let i = 0, len = pathSplit.length; i < len; i += 1) {
    childObject = childObject[pathSplit[i]];
    if (!childObject) { return false; }
  }
  return true;
}

function getValueForPropertyPath(object, path) {
  const pathSplit = path.split('.');
  const { length } = pathSplit;
  let index = 0;

  let returnObj = object;
  while (returnObj != null && index < length) {
    returnObj = returnObj[pathSplit[index]];
    index += 1;
  }
  return (index && index === length) ? returnObj : undefined;
}

function slugify(string, separator = '-') {
  if (!string) return 'undefined';
  return string
    .toString()
    .normalize('NFD') // split an accented letter
    .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 -]/g, '') // remove all other chars
    .replace(/\s+/g, separator);
}

function scrollToElement(el, offset) {
  window.scrollTo({
    behavior: 'smooth',
    top:
      el.getBoundingClientRect().top
      - document.body.getBoundingClientRect().top
      - offset,
  });
}

function debounce(callback, wait) {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
}

function camelize(str) {
  return str.replace(/\W+(.)/g, (match, chr) => chr.toUpperCase());
}

function equalsIgnoreOrder(a, b) {
  if (a.length !== b.length) return false;
  const uniqueValues = new Set([...a, ...b]);
  uniqueValues.forEach((v) => {
    const aCount = a.filter((e) => e === v).length;
    const bCount = b.filter((e) => e === v).length;
    return aCount === bCount;
  });
  return true;
}

function addDashboardRefParameter(url) {
  try {
    const testUrl = new URL(url);
    const refParam = testUrl.searchParams.get('ref');
    if (refParam) {
      if (refParam === 'dashboard') {
        return url;
      }
      testUrl.searchParams.set('ref', 'dashboard');
      return testUrl;
    }
    const paramUrl = new URL(
      `${testUrl.origin}${testUrl.pathname}?${new URLSearchParams([
        ...Array.from(testUrl.searchParams.entries()),
        ...Object.entries({ ref: 'dashboard' }),
      ])}`,
    );

    return paramUrl;
  } catch (e) {
    console.warn('addDashboardRefParameter error', e.message);
    if (!url) return '';
    return url.indexOf('?') !== -1 ? `${url}&ref=dashboard` : `${url}?ref=dashboard`;
  }
}

function localizeContent(text) {
  const localeLanguage = document.documentElement.lang || 'en';
  const localeTenant = document.body.getAttribute('data-tenant') || 'GB';
  let localeParam = `${localeLanguage}-${localeTenant}`;
  try {
    text.toLocaleString(localeParam);
  } catch (error) {
    localeParam = 'en-GB';
  }
  return text.toLocaleString(localeParam);
}

export {
  hasOwnDeepProperty,
  getValueForPropertyPath,
  slugify,
  scrollToElement,
  debounce,
  camelize,
  equalsIgnoreOrder,
  addDashboardRefParameter,
  localizeContent,
};
